type TabPanelProps = {
  children: React.ReactNode;
  hidden: boolean;
};

export const TabPanel: React.FC<TabPanelProps> = ({ children, hidden }) => {
  return <div hidden={hidden} style={{ flex: 1 }}>{children}</div>;
};
